import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../';
import { useCardSetsFilterParams, useProfileIsRight } from '../../hooks';
import { cleanCardSetsRelationSelectAndStore, getCardSetsRelationSelect } from '../../middleware';
import { CardSetsTableList } from './Components';

export const CardSetsList: React.FC = observer(() => {
    const filterParams = useCardSetsFilterParams();
    const isUser = useProfileIsRight('USER');

    return (
        <Catcher>
            <ListWrapper
                cleanStore={cleanCardSetsRelationSelectAndStore}
                filterParams={filterParams}
                getRelationSelect={getCardSetsRelationSelect}
                uploadApiType={isUser ? 'POST_CARD_SET_LIST_CSV' : undefined}
            >
                <CardSetsTableList />
            </ListWrapper>
        </Catcher>
    );
});
